// const check = document.querySelector('overflow-hidden-tablet');
const test = document.querySelector('.dt-video__init');
const content = test.querySelectorAll('.Scroll-animation');

const animationDuration = 600;
const idlePeriod = 0;
let lastAnimation = 0;
let index = 0;

const toggleText = (index, state) => {
  const classList = content[index].querySelector('.text').classList
  state === 'show' ? classList.add('show') : classList.remove('show')
}

const slideTo = dir => {
  const timeNow = new Date().getTime();
  const nextSlide = index + dir
  
  if (timeNow - lastAnimation < animationDuration) return
  if (nextSlide < 0 || nextSlide >= content.length) return
  
  toggleText(index, 'hide')
  
  lastAnimation = timeNow;
  index = nextSlide
  
  content.forEach((div, i) => {    
 
    if (i === index) {
      toggleText(i, 'show');
     // div.scrollIntoView({behavior: "smooth"});
    }
 
  })
  // text.textContent = index
}

toggleText(0, 'show');

const text = document.querySelector('.nav span');
document.addEventListener('wheel', e => { 
  slideTo(e.deltaY > 0 ? 1 : -1) }
)

var yDown = null;

const handleTouchStart = evt => {
  yDown = evt.touches[0].clientY
}
                                   
// const handleTouchMove = evt => {
//   if (!yDown) return

//   var yUp = evt.touches[0].clientY;

//   var yDiff = yDown - yUp;
  
//   slideTo(yDiff > 0 ? 1 : -1)
   
//   yDown = null
// };



document.addEventListener('touchstart', handleTouchStart, true);        
// document.addEventListener('touchmove', handleTouchMove, true);

